var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bg-gray-2 text-dark offer-attributes" }, [
    _c(
      "div",
      { staticClass: "container-fluid pb-1 px-0" },
      [
        _vm.offerApiResponse
          ? [
              _vm.offerApiResponse.discountInfoBanner
                ? _c("discount-info-banner", {
                    staticClass: "discount-info-banner",
                    attrs: {
                      text: _vm.offerApiResponse.discountInfoBanner.text,
                      overlay: _vm.offerApiResponse.discountInfoBanner.overlay,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "position-relative mb-1" },
                [
                  _c(
                    "div",
                    { staticClass: "py-0" },
                    [
                      _c("Lien", {
                        attrs: {
                          "is-link-arrow-back": true,
                          href: _vm.offerApiResponse.backLink.url,
                          label: "Retour",
                          "tms-category":
                            _vm.offerApiResponse.backLink.tms.category +
                            "_haut",
                          "tms-action":
                            _vm.offerApiResponse.backLink.tms.action,
                          "tms-label": _vm.offerApiResponse.backLink.tms.label,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "bg-primary3 banner" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-white text-black mx-1 mx-md-0 px-2 pb-1 mt-5 content-overlay",
                    },
                    [
                      _c("div", { staticClass: "row mb-1 header-title" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 d-flex justify-content-between position-relative",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-6 col-lg-12 align-self-start commercial-tag",
                              },
                              [
                                _vm.offerApiResponse.offer.tag
                                  ? _c("CommercialTag", {
                                      attrs: {
                                        label: _vm.offerApiResponse.offer.tag,
                                        version: "information",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.offerApiResponse.offer.visual.url
                              ? _c("img", {
                                  staticClass: "product-image",
                                  attrs: {
                                    src: _vm.offerApiResponse.offer.visual.url,
                                    alt: _vm.offerApiResponse.offer.visual.alt,
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-md-9 mt-1" }, [
                          _c("h1", { staticClass: "mb-0" }, [
                            _vm._v(_vm._s(_vm.offerApiResponse.offer.name)),
                          ]),
                          _vm._v(" "),
                          _vm.offerApiResponse.offer.attributes &&
                          _vm.offerApiResponse.offer.attributes.title
                            ? _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.offerApiResponse.offer.attributes
                                        .title
                                    ) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-md-3 mt-1" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-items-md-end",
                            },
                            [
                              _c("Price", {
                                attrs: {
                                  price:
                                    _vm.offerApiResponse.offer.price
                                      .priceInCents,
                                  "initial-price":
                                    _vm.offerApiResponse.offer.price
                                      .initialPriceInCents,
                                  "show-by-month":
                                    _vm.offerApiResponse.offer.price
                                      .showByMonth,
                                  "show-from":
                                    _vm.offerApiResponse.offer.price.showFrom,
                                  duration:
                                    _vm.offerApiResponse.offer.price.duration,
                                  "price-details":
                                    _vm.offerApiResponse.offer.price
                                      .priceDetails,
                                  "price-label":
                                    _vm.offerApiResponse.offer.price.priceLabel,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.offerApiResponse.buttonCta
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column align-items-center align-items-md-end mt-1 mt-md-0",
                                },
                                [
                                  _c("Bouton", {
                                    ref: "topCtaButton",
                                    staticClass: "mw-100 w-100 w-md-auto",
                                    attrs: {
                                      "is-button": _vm.ctaIsButton,
                                      label:
                                        _vm.offerApiResponse.buttonCta.label,
                                      href: _vm.offerApiResponse.buttonCta.href,
                                      "tms-category":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .category + "_haut",
                                      "tms-action":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .action,
                                      "tms-label":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .label,
                                    },
                                    on: { click: _vm.handleCtaClick },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("hr", {
                        staticClass: "separator separator--gray4 w-100",
                        class: _vm.offerApiResponse.buttonCta
                          ? "d-none d-md-block"
                          : "",
                      }),
                      _vm._v(" "),
                      _vm.offerApiResponse.offer.attributes
                        ? _c(
                            "div",
                            { ref: "offerDetails" },
                            _vm._l(
                              _vm.offerApiResponse.offer.attributes.details,
                              function (attribute, index) {
                                return _c(
                                  "div",
                                  { key: "offer-attribute-" + index },
                                  [
                                    _c("div", { staticClass: "py-1" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex my-1 align-items-start mb-1",
                                        },
                                        [
                                          _c("div", { staticClass: "me-1" }, [
                                            _c("span", {
                                              staticClass:
                                                "h4 icon icon-livebox-s",
                                              class: attribute.icon,
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column w-100",
                                            },
                                            [
                                              _c("div", {
                                                directives: [
                                                  {
                                                    name: "safe-html",
                                                    rawName: "v-safe-html",
                                                    value:
                                                      attribute.descriptionBbcode,
                                                    expression:
                                                      "attribute.descriptionBbcode",
                                                  },
                                                ],
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr", {
                        staticClass: "separator separator--gray4 w-100",
                        class: _vm.offerApiResponse.buttonCta ? "d-none" : "",
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "ob1-skeleton my-1" }, [
                        _c(
                          "div",
                          { staticClass: "back-button" },
                          [
                            !_vm.offerApiResponse.buttonCta
                              ? _c("Lien", {
                                  attrs: {
                                    "is-link-arrow-back": true,
                                    href: _vm.offerApiResponse.backLink.url,
                                    label: _vm.offerApiResponse.backLink.label,
                                    "tms-category":
                                      _vm.offerApiResponse.backLink.tms
                                        .category + "_bas",
                                    "tms-action":
                                      _vm.offerApiResponse.backLink.tms.action,
                                    "tms-label":
                                      _vm.offerApiResponse.backLink.tms.label,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.aiChatbotStarter
                    ? _c("AiChatbotStarter", {
                        attrs: {
                          dto: _vm.aiChatbotStarter,
                          "custom-class": "pt-4 px-1 px-md-0",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerApiResponse.offer.zigZag
                    ? _c("div", { staticClass: "pt-4 px-1 px-md-0" }, [
                        _c(
                          "div",
                          { staticClass: "bg-white px-2 py-2" },
                          [
                            _c("EditorialPush", {
                              attrs: {
                                zigzag: _vm.offerApiResponse.offer.zigZag,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerApiResponse.buttonCta
                    ? _c("div", { staticClass: "pt-4 px-1 px-md-0" }, [
                        _c("div", { staticClass: "bg-white px-2 py-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-md-row justify-content-md-between align-items-md-start",
                            },
                            [
                              _c(
                                "h3",
                                { staticClass: "mb-0 align-self-md-center" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.offerApiResponse.offer.name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column align-items-start align-items-md-end",
                                },
                                [
                                  _c("Price", {
                                    attrs: {
                                      price:
                                        _vm.offerApiResponse.offer.price
                                          .priceInCents,
                                      "initial-price":
                                        _vm.offerApiResponse.offer.price
                                          .initialPriceInCents,
                                      "show-by-month":
                                        _vm.offerApiResponse.offer.price
                                          .showByMonth,
                                      "show-from":
                                        _vm.offerApiResponse.offer.price
                                          .showFrom,
                                      duration:
                                        _vm.offerApiResponse.offer.price
                                          .duration,
                                      "price-details":
                                        _vm.offerApiResponse.offer.price
                                          .priceDetails,
                                      "price-label":
                                        _vm.offerApiResponse.offer.price
                                          .priceLabel,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("Bouton", {
                                    ref: "bottomCtaButton",
                                    staticClass:
                                      "mw-100 w-100 w-md-auto align-self-center align-self-md-start",
                                    attrs: {
                                      "is-button": _vm.ctaIsButton,
                                      label:
                                        _vm.offerApiResponse.buttonCta.label,
                                      href: _vm.offerApiResponse.buttonCta.href,
                                      "tms-category":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .category + "_bas",
                                      "tms-action":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .action,
                                      "tms-label":
                                        _vm.offerApiResponse.buttonCta.tms
                                          .label,
                                    },
                                    on: { click: _vm.handleCtaClick },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerApiResponse.offer.faq
                    ? _c("div", { staticClass: "pt-4 px-1 px-md-0" }, [
                        _c(
                          "div",
                          { staticClass: "bg-white px-2 py-2" },
                          [
                            _c("ShowcaseFaq", {
                              attrs: {
                                "faq-title":
                                  _vm.offerApiResponse.offer.faq.faqTitle,
                                "faq-list-of-attributes":
                                  _vm.offerApiResponse.offer.faq
                                    .faqListOfAttributes,
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", {
                    staticClass: "separator separator--gray4 w-100 mt-2",
                  }),
                  _vm._v(" "),
                  _c("LegalMentions", {
                    staticClass: "pt-2",
                    attrs: {
                      "legal-mentions": _vm.offerApiResponse.legalMentions,
                    },
                  }),
                  _vm._v(" "),
                  _c("hr", {
                    staticClass: "separator separator--gray4 w-100 mt-2",
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row px-1 px-md-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mt-1" },
                      [
                        _c("Breadcrumb", {
                          attrs: {
                            "custom-aria-label": "Fil d'ariane",
                            label:
                              _vm.offerApiResponse.breadcrumb.lastElementLabel,
                            "breadcrumb-items": _vm.breadcrumbItems,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.offerApiResponse.offer.attributes != null
                    ? _c(
                        "div",
                        [
                          _vm.offerApiResponse.offer.attributes.genericPopins
                            ? _vm._l(
                                _vm.offerApiResponse.offer.attributes
                                  .genericPopins,
                                function (editoPopin, index) {
                                  return _c("EditoPopin", {
                                    key: editoPopin.id,
                                    ref: (el) =>
                                      _vm.addEditoPopinRef(
                                        el,
                                        index,
                                        editoPopin.id
                                      ),
                                    refInFor: true,
                                    attrs: {
                                      "popin-id": editoPopin.popinModal.id,
                                      title: editoPopin.title,
                                      visual: editoPopin.visual,
                                      sections: editoPopin.sections,
                                      mentions: editoPopin.mentions,
                                    },
                                  })
                                }
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.offerApiResponse.offer.attributes
                            .mobileOptionPopin
                            ? _c("OptionEditoPopin", {
                                ref: "optionEditoPopin",
                                attrs: {
                                  "popin-id":
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.popinModal.id,
                                  title:
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.title,
                                  visual:
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.visual,
                                  sections:
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.sections,
                                  mentions:
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.mentions,
                                  price:
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.priceInCents,
                                  "alert-message":
                                    _vm.offerApiResponse.offer.attributes
                                      .mobileOptionPopin.alertMessage,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.offerApiResponse.offer.attributes
                            .destinationsPopin
                            ? _c("ThreeColumnsEditoPopin", {
                                ref: "threeColumnsEditoPopin",
                                attrs: {
                                  "popin-id":
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.popinModal.id,
                                  title:
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.title,
                                  visual:
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.visual,
                                  sections:
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.sections,
                                  mentions:
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.mentions,
                                  "first-column-sections":
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.firstColumnSections,
                                  "second-column-sections":
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.secondColumnSections,
                                  "third-column-sections":
                                    _vm.offerApiResponse.offer.attributes
                                      .destinationsPopin.thirdColumnSections,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.offerApiResponse.offer
                            .mobilePopinIncludedCountries
                            ? _c("EditoPopin", {
                                ref: "editoPopin",
                                attrs: {
                                  "popin-id":
                                    _vm.offerApiResponse.offer
                                      .mobilePopinIncludedCountries.id,
                                  title:
                                    _vm.offerApiResponse.offer
                                      .mobilePopinIncludedCountries.title,
                                  visual:
                                    _vm.offerApiResponse.offer
                                      .mobilePopinIncludedCountries.visual,
                                  sections:
                                    _vm.offerApiResponse.offer
                                      .mobilePopinIncludedCountries.sections,
                                  mentions:
                                    _vm.offerApiResponse.offer
                                      .mobilePopinIncludedCountries.mentions,
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.offerApiResponse.modalAfterAddToCart
                    ? _c("ModalAfterAddToCart", {
                        ref: "modalAfterAddToCart",
                        attrs: {
                          content: _vm.offerApiResponse.modalAfterAddToCart,
                          "offer-name": _vm.offerApiResponse.offer.name,
                          "modal-id":
                            "intention-" + _vm.offerApiResponse.offer.seoId,
                          "first-intention-href":
                            "/mobile/choisir-un-smartphone",
                          "second-intention-href": "/panier",
                          "tms-category": "fiche_offre",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          : [_c("SkeletonOfferDetailPage")],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }